import { toZonedTime } from 'date-fns-tz'
import { TFunction } from 'i18next'
import z from 'zod'

import { DEFAULT_LIMIT } from '@/components/ui/pagination/pagination.constants'
import { TableColumn } from '@/components/ui/table'
import { EMPTY_VALUE } from '@/constants'
import { PackageRoomSession } from '@/models'
import { formatDateOnly, formatTimeOnly, getCarrierName } from '@/utils'

import { GetPackageLogColumnsParams } from './package-log.types'

export const getPackageLogColumns = ({
  timezone = 'America/Chicago',
  t,
}: GetPackageLogColumnsParams & {
  t: TFunction<['packages']>
}): TableColumn<PackageRoomSession>[] => [
  {
    id: 'sessionId',
    render: (session) => session.sessionId,
    title: t('packages:log.columns.sessionId'),
    width: '28rem',
  },
  {
    id: 'date',
    render: (session) => {
      const zonedDate = toZonedTime(session.endTime, timezone)
      return `${formatDateOnly(zonedDate)}\n${formatTimeOnly(zonedDate)}`
    },
    title: t('packages:log.columns.date'),
    width: '28rem',
  },
  {
    id: 'packagesRegistered',
    render: (session) => session.packageCount,
    title: t('packages:log.columns.packagesRegistered'),
    width: '28rem',
  },
  {
    id: 'carrier',
    render: (session) =>
      session.carriers?.length ? session.carriers.map(getCarrierName).join(', ') : EMPTY_VALUE,
    title: t('packages:log.columns.carrier'),
    width: '41.6rem',
  },
]

export const packageLogQueryFiltersSchema = z.object({
  fromDate: z.coerce.number().optional(),
  limit: z.coerce.number().optional(),
  skip: z.coerce.number().optional(),
  toDate: z.coerce.number().optional(),
})

export const packageLogInitialFilters: z.infer<typeof packageLogQueryFiltersSchema> = {
  fromDate: undefined,
  limit: DEFAULT_LIMIT,
  skip: 0,
  toDate: undefined,
}
